query getMarketNews($market_id: String, $compact: Boolean) {
  getMarketNews(market_id: $market_id, compact: $compact) 
}